import { render } from "./ConvisoIcon.vue?vue&type=template&id=e0a99b68&scoped=true"
import script from "./ConvisoIcon.vue?vue&type=script&lang=js"
export * from "./ConvisoIcon.vue?vue&type=script&lang=js"

import "./ConvisoIcon.vue?vue&type=style&index=0&id=e0a99b68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0a99b68"]])

export default __exports__